import { useQuery } from 'react-query';
import { client } from '@frontend/features/common/services';
import { CONFIG } from '@frontend/config';
export const catalogAdminPath = '/dashboard/hotel-catalog-admin';
export const catalogAdminKey = ['hotel-catalog-admin', CONFIG.AGENCY_ID];
export const useCatalogAdminCapability = () =>
  useQuery({
    queryKey: [...catalogAdminKey, 'capability'],
    queryFn: async () => (await client.get<{ allowed: boolean }>('hotel-catalog-admin/capability')).data,
    retry: false,
    staleTime: 0,
  });
export * from './selection';
